import { useContext } from "react";
import { SplitContext } from "@splitsoftware/splitio-react";
import { ISplitContextValues } from "@splitsoftware/splitio-react/types/types";

import { FeatureFlag } from "../featureFlags";

export const useSplitContext = (): ISplitContextValues => useContext(SplitContext);
function useFeatureFlag(featureName: FeatureFlag): boolean {
  const { client } = useSplitContext();
  return client?.getTreatment(featureName) === "on";
}
export default useFeatureFlag;
